import { IDocumentFolderWithAccess } from '@api/models';
import { addUserToFolder } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface AddUserToDocumentOptions {
    clientId: string;
    folder: IDocumentFolderWithAccess;
    folderId?: string;
}

const useAddUserToDocumentForm = (options: AddUserToDocumentOptions) => {
    const { folder, clientId } = options;

    const addUserToDocumentMutation = useMutation((userIds: string[]) =>
        addUserToFolder(clientId, folder._id, userIds)
    );

    const submit = async (value: string[]) => {
        await addUserToDocumentMutation.mutateAsync(value);
    };

    return {
        isLoading: addUserToDocumentMutation.isPending,
        submit,
    };
};

export default useAddUserToDocumentForm;
